import React from 'react';

/**
 * LightModeWrapper
 * 
 * Isolates the website renderer from the editor's dark mode theme.
 * This ensures that user-created websites always display as designed,
 * regardless of the editor's theme setting.
 * 
 * The wrapper removes the 'dark' class from its subtree by forcing
 * a 'light' class, which overrides the document-level dark mode.
 */
const LightModeWrapper = ({ children }) => {
  return (
    <div className="light" data-theme="light">
      {children}
    </div>
  );
};

export default LightModeWrapper;


